export const dataBought = [
    {
        head_uz: 'Sotib ol',
        head_ru: 'Покупай',
    },
    {
        name_uz: 'Mac',
        name_ru: 'Mac',
    },
    {
        name_uz: 'iPad',
        name_ru: 'iPad',
    },
    {
        name_uz: 'iPhone',
        name_ru: 'iPhone',
    },
];

export const dataCompony = [
    {
        head_uz: 'Kompaniya',
        head_ru: 'Компания',
    },
    {
        name_uz: 'Yangiliklar',
        name_ru: 'Новости',
    },
    {
        name_uz: 'Kompaniya haqida',
        name_ru: 'О компании',
    },
    {
        name_uz: "Do'kon manzillari",
        name_ru: 'Адреса магазинов',
    },
    {
        name_uz: 'Biznes uchun',
        name_ru: 'Для бизнеса',
    },
]

export const dataInformation = [
    {
        head_uz: "Ma'lumot",
        head_ru: 'Информация',
    },
    {
        name_uz: 'Siz uchun sotib beramiz!',
        name_ru: 'Мы продаем для вас',
    },
    {
        name_uz: "Yetkazib berish",
        name_ru: 'Доставка',
    },
    {
        name_uz: 'Aloqa',
        name_ru: 'Контакты',
    },
    {
        name_uz: 'Taklif bildirish',
        name_ru: 'Предложить идею',
    },
    {
        name_uz: 'eSIM haqida',
        name_ru: 'о eSIM',
    },
]

export const dataContact = [
    {
        head_uz: "Biz bilan bog'laning",
        head_ru: 'Связаться с нами'
    }
]